import { useState } from "react";
import {
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
  sendPasswordResetEmail,
} from "firebase/auth";
import { auth } from "../firebase/firebase";
import Header from "../components/Header/Header";

/**
 * Clean, user-friendly auth error messages
 * (Never expose Firebase wording to users)
 */
const AUTH_ERROR_MESSAGES = {
  "auth/invalid-credential": "Incorrect email or password.",
  "auth/user-not-found": "No account found with this email.",
  "auth/wrong-password": "Incorrect email or password.",
  "auth/popup-closed-by-user": "Sign-in was cancelled.",
  "auth/too-many-requests":
    "Too many failed attempts. Please try again later.",
  "auth/network-request-failed":
    "Network error. Please check your internet connection.",
};

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const getErrorMessage = (err) => {
    if (err && err.code && AUTH_ERROR_MESSAGES[err.code]) {
      return AUTH_ERROR_MESSAGES[err.code];
    }
    return "Something went wrong. Please try again.";
  };

  const handleEmailLogin = async () => {
    setError("");
    setSuccess("");

    if (!email || !password) {
      setError("Please enter both email and password.");
      return;
    }

    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError(getErrorMessage(err));
    }
  };

  const handleGoogleLogin = async () => {
    setError("");
    setSuccess("");

    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
    } catch (err) {
      setError(getErrorMessage(err));
    }
  };

  const handlePasswordReset = async () => {
    setError("");
    setSuccess("");

    if (!email) {
      setError("Please enter your email address to reset your password.");
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      setSuccess(
        "Password reset link sent. Please check your email inbox."
      );
    } catch (err) {
      setError(getErrorMessage(err));
    }
  };

  return (
    <>
      <Header />

      <div
        style={{
          minHeight: "calc(100vh - 72px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "40px 24px",
        }}
      >
        <div
          className="card"
          style={{
            width: "100%",
            maxWidth: 420,
            padding: 32,
          }}
        >
          <h1 style={{ marginBottom: 8 }}>Login</h1>

          <p
            style={{
              marginBottom: 24,
              fontSize: 14,
              color: "#64748b",
            }}
          >
            Sign in to access your Prufyy dashboard
          </p>

          {error && (
            <div
              style={{
                marginBottom: 16,
                padding: 10,
                backgroundColor: "#fee2e2",
                color: "#991b1b",
                borderRadius: 6,
                fontSize: 13,
              }}
            >
              {error}
            </div>
          )}

          {success && (
            <div
              style={{
                marginBottom: 16,
                padding: 10,
                backgroundColor: "#dcfce7",
                color: "#166534",
                borderRadius: 6,
                fontSize: 13,
              }}
            >
              {success}
            </div>
          )}

          {/* Email */}
          <div style={{ marginBottom: 16 }}>
            <input
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 12px",
                borderRadius: 6,
                border: "1px solid #e5e7eb",
                fontSize: 14,
              }}
            />
          </div>

          {/* Password */}
          <div style={{ marginBottom: 8 }}>
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 12px",
                borderRadius: 6,
                border: "1px solid #e5e7eb",
                fontSize: 14,
              }}
            />
          </div>

          {/* Forgot password */}
          <div
            style={{
              textAlign: "right",
              marginBottom: 20,
            }}
          >
            <button
              onClick={handlePasswordReset}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                fontSize: 13,
                color: "#2563eb",
                cursor: "pointer",
              }}
            >
              Forgot your password?
            </button>
          </div>

          {/* Email login */}
          <button
            className="btn-primary"
            style={{ width: "100%", marginBottom: 12 }}
            onClick={handleEmailLogin}
          >
            Login with Email
          </button>

          {/* Divider */}
          <div
            style={{
              textAlign: "center",
              fontSize: 13,
              color: "#94a3b8",
              margin: "16px 0",
            }}
          >
            or
          </div>

          {/* Google login */}
          <button
            className="btn-secondary"
            style={{ width: "100%" }}
            onClick={handleGoogleLogin}
          >
            Continue with Google
          </button>
        </div>
      </div>
    </>
  );
}

export default Login;
